import { Spinner } from '@origin-digital/style-guide';
import * as React from 'react';
import { MouseEvent } from 'react';
import { UndecoratedLink } from 'ts/components/UndecoratedLink';

interface ResendViewProps {
  resendSpinner: boolean;
  onResendClicked: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const ResendCodeView: React.FC<ResendViewProps> = ({ resendSpinner, onResendClicked }) => {
  return resendSpinner ? (
    <Spinner data-id="resend-spinner" show={true} />
  ) : (
    <UndecoratedLink
      color="red"
      data-id="resend-button"
      href="#"
      onClick={onResendClicked}
      text="Get a new code"
    />
  );
};

export { ResendCodeView };
